import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { COWTUXSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        COWTUXSearchBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        COWTUXSearchBarComponent
    ]
})
export class COWTUXSearchBarModule
{
}
